module.exports = {"Description":"SM : 4789N","RedundantCharacters":" -","ValidationRegex":"^4789[0-9]{1}$","TestData":{"Valid":["47890","47899"],"Invalid":["4789","478900","47889"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/SM.json
// module id = 4486
// module chunks = 11